<template>
    <DefaultTemplate :model="model">
        <div class="bg-white h-fit">
            <div v-show="inEditMode">
                <EpiProperty propertyName="Header" displayText="Header"/>
                <EpiProperty propertyName="CategoryNavigation" displayText="Kategorinavigasjon"/>
                <EpiProperty propertyName="Footer" displayText="Footer"/>
            </div>
            <StartPageHero :title="model.startPageTitle" :navigation-links="model.heroLinks" :entry="model.entry"/>
            <HighlightedArticle v-if="model.highlightedArticle"
                                class="container"
                                :article="model.highlightedArticle"
                                :url="model.highlightedArticleUrl"
                                :rightcontent="model.rightContent" />
            <ContentArea v-epi-edit="'MainContent'" class="container" :model="model.mainContent"/>
            <div class="bg-sand lg:py-[60px]">
                <ContentArea class="container" v-epi-edit="'SecondaryContent'" :model="model.secondaryContent"/>
            </div>
            <CategoryNavigation v-if="model.categoryNavigation && model.categoryNavigation.kategorier"
                                :categories="model.categoryNavigation.kategorier"
                                :heading="model.categoryNavigation.heading"
                                :view="model.view"
                                :description="model.categoryNavigation.description"/>
        </div>
    </DefaultTemplate>
</template>

<script>
import HighlightedArticle from '@/Scripts/components/organisms/Highlighted/HighlightedArticle.vue';
import ContentArea from '@/Scripts/components/ContentArea.vue';
import Container from '@/Scripts/components/atoms/Container/index.vue';
import Slider from '@/Scripts/components/organisms/Slider/slider.vue';
import CategoryNavigation from '@/Scripts/components/organisms/CategoryNavigation/startpage.vue';
import EpiProperty from '@/Scripts/components/EpiProperty.vue';
import {mapState} from 'vuex';
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';
import StartPageHero from '@/Scripts/components/organisms/Hero/StartPageHero.vue';

export default {
    props: ['model'],
    mounted() {
        console.log('StartPage model:', this.model.heroLinks);
    },
    computed: mapState({
        inEditMode: state => state.epiContext.inEditMode
    }),
    components: {
        StartPageHero,
        EpiLink,
        HighlightedArticle,
        ContentArea,
        Container,
        Slider,
        CategoryNavigation,
        EpiProperty
    }
};
</script>
